export const COOPERATION_AGREEMENT_EN_NAME = "Daytrip cooperation agreement";
